













import { defineComponent, ref } from '@vue/composition-api'
import { TcSelectionButton } from '@telia/shared-ui-components'

export enum SelectionButtonVariant {
  Default = 'default',
  SingleValue = 'single-value'
}

export enum SelectionButtonSelectionType {
  SingleSelect = 'singleselect',
  MultiSelect = 'multiselect'
}

export enum SelectionButtonColumnAmount {
  Two = '2',
  Three = '3',
  Four = '4'
}

export default defineComponent({
  components: {
    TcSelectionButton
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [
        String,
        Object,
        Number,
        Boolean
      ]
    },
    buttonValue: {
      type: [
        String,
        Object,
        Number,
        Boolean
      ]
    },
    name: {
      type: String
    },
    variant: {
      type: String,
      default: SelectionButtonVariant.Default
    },
    selectionType: {
      type: String,
      default: SelectionButtonSelectionType.SingleSelect
    },
    columnAmount: {
      type: String,
      default: SelectionButtonColumnAmount.Two
    }
  },
  setup: ({ value }) => ({ internalValue: ref(value) })
})
